/**
 * Module Constants
 */
export const STORE_NAME = 'core/patterns';
